import { render } from "./LivenessVerificationV1.vue?vue&type=template&id=1021b9dc"
import script from "./LivenessVerificationV1.vue?vue&type=script&lang=js"
export * from "./LivenessVerificationV1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__